import getResponse from './ApiClient';

const getLoader = (loading) => {
  if (loading && loading.start && loading.stop) {
    return loading;
  }

  if (!loading) {
    return {
      // eslint-disable-next-line prettier/prettier
      start: () => { },
      // eslint-disable-next-line prettier/prettier
      stop: () => { }
    };
  }

  return {
    start: () => loading(true),
    stop: () => loading(false)
  };
};

/**
 *
 * @param {String | Object } endpoint : {path | method | baseURL | multipart }
 * @param { Object } params : query parameters
 * @param { Object} data : body
 * @param { Function } loading : state setter for loading
 * @param { Function } onSucess : run on success
 * @param { Function } onFailure : run on failure
 * @param { Function } afterFetch : run after api call
 */

const CallApi = async (endpoint, params, data, loading, onSucess, onFailure, afterFetch = null) => {
  const loader = getLoader(loading);
  try {
    loader.start();
    const res = await getResponse(endpoint, params, data);
    if (res.status.statusCode !== 5000) {
      throw new Error(JSON.stringify(res.data));
    }
    onSucess(res.data);
    if (afterFetch) afterFetch(res);
  } catch (error) {
    if (onFailure) onFailure(error);
  } finally {
    loader.stop();
  }
};

export default CallApi;
